import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';
import { Text } from 'tradera/components/atoms/text/text';
import { HeaderWithCloseButton } from 'tradera/components/scrollable-modal/header-with-close-button';
import { useSelector } from 'react-redux';
import { useTranslator } from 'tradera/lang/translate';
import { selectMemberBirthdate } from 'tradera/state/member/selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Underage } from './underage';

dayjs.extend(customParseFormat);

type UnderageModalProps = {
    onClose: () => void;
    show: boolean;
};

export const UnderageModal = ({ show, onClose }: UnderageModalProps) => {
    const { t } = useTranslator();

    const memberBirthdate = useSelector(selectMemberBirthdate);

    const daysUntilEighteen = dayjs(memberBirthdate as string, 'YYMMDD')
        .add(18, 'year')
        .diff(dayjs(), 'day');

    return (
        <ScrollableModal
            show={show}
            maxWidth="40rem"
            onClose={onClose}
            header={<HeaderWithCloseButton onClose={onClose} />}>
            <div className="d-flex justify-content-center mb-1">
                <Underage onLinkClick={onClose}>
                    {daysUntilEighteen <= 100 && (
                        <Text className="text-center text-styled mt-1">
                            {t('underageModal_countdown', {
                                days: daysUntilEighteen,
                            })}
                        </Text>
                    )}
                </Underage>
            </div>
        </ScrollableModal>
    );
};
